'use strict';

/**
 * Contains the logic for the item-added-to-cart
 * notification modal.
 */

module.exports = /*@ngInject*/
function(
    $,
    $timeout,
    AnthroConfig,
    CartService,
    ResponsiveService
) {
    return {
        scope: {},
        templateUrl: AnthroConfig.location.root + '/partials/add-to-bag-modal.html',
        link: function(scope, element, attrs) {
            var m = scope.model = {
                itemQty: '',
                itemText: '',
                siteContext: window.location.href.indexOf('/m/') > -1 ? AnthroConfig.location.root + '/m' : AnthroConfig.location.root
            };

            var a = scope.action = {
                /**
                 * Animates the modal using jQuery
                 * @return {Object} jQuery add-to-bag-panel element
                 */
                animateModal: function() {
                    var panel = $('.add-to-bag-panel');

                    return panel.slideDown(function() {
                        $timeout(function() {
                            panel.slideUp();
                        }, 2000);
                    });
                },

                /**
                 * Gets the bag count offset from its left edge.
                 * It no offset exists, it returns zero.
                 * @return {Number} Bag count offset in pixels
                 */
                getBagCountOffset: function() {
                    var offset = $('.bagCount:visible').offset();
                    return offset ? offset.left : 0;
                },

                /**
                 * Gets the correct item text based on the quantity
                 * of items added to the bag.
                 * @param  {Number} qty Item quantity added to the bag
                 * @return {String}     Correct item text
                 */
                getItemText: function(qty) {
                    return qty === 1 ? 'item' : 'items';
                },

                /**
                 * Is the current header the rwd-header?
                 * @return {Boolean} True, if the current header is the rwd-header; false, otherwise.
                 */
                isSmallScreenHeader: function() {
                    return $('.rwd-page-header .bagCount').is(':visible');
                },

                /**
                 * Offsets the add-to-bag modal so that it covers the
                 * cart count and doesn't disappear off the right edge
                 * of the viewport.
                 * @return {Ojbect} jQuery add-to-bag-panel element
                 */
                offsetModal: function() {
                    var offset = a.isSmallScreenHeader() ? 260 : 280;
                    var position = a.getBagCountOffset() - offset;

                    return $('.add-to-bag-panel').css('left', position);
                },

                /**
                 * Contains all the business logic required
                 * to show the add-to-bag modal correctly
                 * @param  {Object} event jQuery event object
                 * @param  {Object} data  Data passed to the Notification event
                 */
                showModal: function(event, data) {
                    m.itemQty = data.qty;
                    m.itemText = a.getItemText(data.qty);

                    if (!ResponsiveService.isMobileContext()) {
                        a.offsetModal();
                    }

                    a.animateModal();
                }
            };

            CartService.onNotification(a.showModal);
        }
    };
};
